function sectionTabsMapReducer(state, { type, payload }) {
  switch (type) {
    case "REGISTER":
      return { ...state, [payload.id]: payload };
    case "UNREGISTER":
      const newState = { ...state };
      delete newState[payload.id];
      return newState;
    default:
      throw new Error(`Unhandled type: ${type}`);
  }
}
function activeSectionTabsMapReducer(state, { type, payload }) {
  switch (type) {
    case "SET":
      return { ...state, [payload.id]: payload };
    case "UNSET":
      const newState = { ...state };
      delete newState[payload.id];
      return newState;
    default:
      throw new Error(`Unhandled type: ${type}`);
  }
}
export {
  activeSectionTabsMapReducer,
  sectionTabsMapReducer
};
//# sourceMappingURL=State.js.map
